
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { NotificationSetting, RateAlertSetting, NotificationSettingConfig } from 'ah-api-gateways';
import cloneDeep from 'lodash/cloneDeep';
import SingleNotificationChannelEditForm from '@/app/components/settings/notifications/SingleNotificationChannelEditForm.vue';
import SingleNotificationTargetEditForm from '@/app/components/settings/notifications/SingleNotificationTargetEditForm.vue';
import SingleNotificationTimeEditForm from '@/app/components/settings/notifications/SingleNotificationTimeEditForm.vue';
import SingleNotificationRateAlertSettingEditForm from '@/app/components/settings/notifications/SingleNotificationRateAlertSettingEditForm.vue';

@Component({
  components: {
    SingleNotificationChannelEditForm,
    SingleNotificationTargetEditForm,
    SingleNotificationTimeEditForm,
    SingleNotificationRateAlertSettingEditForm,
  },
})
export default class SingleNotificationSettingEditForm extends Vue {
  @Prop({ required: true }) config!: NotificationSettingConfig;

  @Prop({ required: true }) notification!: NotificationSetting | RateAlertSetting;

  @Prop({ default: false }) showTitles!: boolean | string;

  @Prop({ default: false }) deletable!: boolean | string;

  @Prop({ default: false }) hideTargets!: string | boolean;

  @Prop({ default: false }) readonly!: string | boolean;

  private editedNotification: NotificationSetting | RateAlertSetting | null = null;

  @Watch('notification', { immediate: true })
  onNotificationChange() {
    this.editedNotification = cloneDeep(this.notification);
  }

  onNotificationUpdate(notification: NotificationSetting) {
    this.editedNotification = notification;
    this.$emit('update:notification', this.editedNotification);
  }

  deleteNotification() {
    this.$emit('delete-notification', this.notification);
  }
}
